import { parseAsBoolean, useQueryState } from "nuqs";

export function useIsEditOrganizationModalOpen(defaultValue: boolean = false) {
    const [isEditOrganizationModalOpen, setEditOrganizationModalOpen] = useQueryState("editOrgModal", parseAsBoolean.withDefault(defaultValue));
    const toggleEditOrganizationModal = () => {
        setEditOrganizationModalOpen(prev=> !prev);
    }
    return { isEditOrganizationModalOpen, setEditOrganizationModalOpen, toggleEditOrganizationModal }
}